import { ConfigProvider, Empty } from "antd";
import viVN from "antd/lib/locale/vi_VN";
import "dayjs/locale/vi";
import { createBrowserHistory } from "history";
import React, { Suspense } from "react";
import { Provider } from "react-redux";
import {
  unstable_HistoryRouter as HistoryRouter,
  Route,
  Routes,
} from "react-router-dom";
// import Body from "../components/Body"
import Body from "../components/layout/AppLayout";
import LoadingProgress from "../components/Loader/LoadingProgress";
import CheckLogin from "../components/PrivateLogin/CheckLogin";
import RoutePrivate from "../components/PrivateLogin/RoutePrivate";
import Page404 from "../pages/404page/Page404";
import { store } from "../redux/configStore";
import AddPermissionInUser from "../pages/Content/Admin/components/ListPermission";
import ListAccout from "../pages/Content/Admin/ListAccout";
import ArticleTable from "../pages/Content/Article/ArticleTable";
import ArticleFormPage from "../pages/Content/Article/ArticleFormPage";
import BannerTable from "../pages/Content/Banner/BannerTable";
import ChangePointSettingTable from "../pages/Content/ChangePoint/ChangePointSettingTable";
import CustomerDetail from "../pages/Content/Customer/CustomerDetail";
import RedeemDiscountCustomer from "../pages/Content/Customer/RedeemDiscount/RedeemDiscountCustomer";
import SendPointCustomer from "../pages/Content/Customer/SendPoint/SendPointCustomer";
import GiftExchangeForCustomerHistories from "../pages/Content/GiftExchange/GiftExchangeForCustomerHistories";
import GiftExchangeForCustomers from "../pages/Content/GiftExchange/GiftExchangeForCustomers";
import GiftExchangeTable from "../pages/Content/GiftExchange/GiftExchangeTable";
import AddGiftExchangePage from "../pages/Content/GiftExchange/AddGiftExchangePage";
import EditGiftExchangePage from "../pages/Content/GiftExchange/EditGiftExchangePage";
import LogActionScreen from "../pages/Content/Log/LogActionScreen";
import LogScreen from "../pages/Content/Log/LogScreen";
import MapServiceBranchTable from "../pages/Content/MapServiceBranch/MapServiceBranchTable";
import ListPermission from "../pages/Content/Permission/ListPermission";
import AddPointPromotionPage from "../pages/Content/PointPromotion/FormAddPointPromotion";
import EditPointPromotionPage from "../pages/Content/PointPromotion/EditPointPromotionPage";
import PointPromotionTable from "../pages/Content/PointPromotion/PointPromotionTable";
import ScanPointOrder from "../pages/Content/PointPromotion/ScanPointOrder";
import RewardDataGwTable from "../pages/Content/RewardDataGw/RewardDataGwTable";
import SurveyResponsesList from "../pages/Content/RewardDataGw/SurveyResponsesList";
import PointMechanismsTable from "../pages/Content/ServiceProject/PointMechanisms/PointMechanismsTable";
import RewardTypeTable from "../pages/Content/ServiceProject/RewardType/RewardTypeTable";
import ZaloEventTable from "../pages/Content/ServiceProject/ZaloEvents/ZaloEventTable";
import SuspensionPointSettingTable from "../pages/Content/SuspensionPointSetting/SuspensionPointSettingTable";
import TrademarkCompanyMapping from "../pages/Content/Trademark/TrademarkCompanyMapping";
import TrademarkTable from "../pages/Content/Trademark/TrademarkTable";
import ZnsEventBranchMapTable from "../pages/Content/ZnsEvent/MappingBranch/ZnsEventBranchMapTable";
import ZnsEventTable from "../pages/Content/ZnsEvent/ZnsEventTable";
import ZaloGroupMessageTable from "../pages/Content/ZaloGroupMessage/ZaloGroupMessageTable";
import CreateMenuPage from "../pages/Menu/components/CreateMenuPage";
import EditMenuPage from "../pages/Menu/components/EditMenuPage";
import ListMenu from "../pages/Menu/listMenu";
import LogMessageHistories from "../pages/Content/Log/LogMessageHistories";
import RewardFormCreate from "../pages/Content/RewardDataGw/RewardFormCreate";
import RewardFormUpdate from "../pages/Content/RewardDataGw/RewardFormUpdate";
import SurveyPublicPage from "../pages/Content/RewardDataGw/SurveypublicPage";
import FeedbackList from "../pages/Content/Feedback/FeedbackList";
import ManufacturerNotificationPage from "../pages/Content/Notification/ManufacturerNotificationPage";

import { dashboardTheme } from "../theme/dashboardTheme";
const TableRankCustomer = React.lazy(() =>
  import("../pages/Content/Customer/RankCustomer/TableRankCustomer")
);
const TransactionCustomer = React.lazy(() =>
  import(
    "../pages/Content/CustomerAccount/TransactionsCustsomer/TransactionCustomer"
  )
);
const FormAddDonate = React.lazy(() =>
  import("../pages/Content/Mcoupon/FormAddDonate")
);
const TableStoreCustomer = React.lazy(() =>
  import("../pages/Content/CustomerAccount/TableStoreCustomer")
);
const TableGroupCustomer = React.lazy(() =>
  import("../pages/Content/Customer/GroupCustomer/TableGroupCustomer")
);
const GroupCustomerDetail = React.lazy(() =>
  import("../pages/Content/Customer/GroupCustomer/GroupCustomerDetail")
);
const GroupCustomerCreate = React.lazy(() =>
  import("../pages/Content/Customer/GroupCustomer/GroupCustomerCreate")
);
const CustomerSee = React.lazy(() =>
  import("../pages/Content/CustomerAccount/CustomerSee")
);
const SendGroupMessages = React.lazy(() =>
  import("../pages/Content/SmsConfig/SendGroupMessages")
);
const DetailHistory = React.lazy(() =>
  import("../pages/Content/Trade/HistoryTrade/DetailHistory")
);
const HistoryTrade = React.lazy(() =>
  import("../pages/Content/Trade/HistoryTrade/HistoryTrade")
);
const Trade = React.lazy(() => import("../pages/Content/Trade/Trade"));
const TabStore = React.lazy(() => import("../pages/Content/Store/TabStore"));

const TableVoucher = React.lazy(() =>
  import("../pages/Content/Mcoupon/VoucherManagement/TableVoucher")
);
const TrashCustomer = React.lazy(() =>
  import("../pages/Content/Customer/TrashCustomer")
);
const TableCustomer = React.lazy(() =>
  import("../pages/Content/Customer/TableCustomer")
);
const EmployeeManager = React.lazy(() =>
  import("../pages/Content/Staff/EmployeeManager")
);
const EditUser = React.lazy(() => import("../pages/User/EditUser"));
const Login = React.lazy(() => import("../pages/Login/Login"));
// const Register = React.lazy(() => import("../pages/Register/Register"));
const TableMcoupon = React.lazy(() =>
  import("../pages/Content/Mcoupon/TableMcoupon")
);
const Restore = React.lazy(() =>
  import("../pages/Content/Mcoupon/RestoreProgram/Restore")
);
// const Home = React.lazy(() => import("../pages/Content/Home/Home"));

const TableService = React.lazy(() =>
  import("../pages/Content/ServiceProject/TableService")
);
const LuckyWheelConfig = React.lazy(() => import("../pages/Content/GamificationConfig/LuckyWheelConfig"));
const ProgramForm = React.lazy(() => import("../pages/Content/GamificationConfig/ProgramForm"));
const GameHistory = React.lazy(() => import("../pages/Content/GamificationConfig/GameHistory"));
// const UserLeaderboard = React.lazy(() => import("../pages/Content/GamificationConfig/UserLeaderboard"));

const ProductCategoryTable = React.lazy(() => import("../pages/Content/Product/ProductCategoryTable"));
const ProductTable = React.lazy(() => import("../pages/Content/Product/ProductTable"));
const ProductCodeManager = React.lazy(() => import("../pages/Content/Shinko/ProductCodeManager"));
const ShinkoPointTransaction = React.lazy(() => import("../pages/Content/Shinko/ShinkoPointTransaction"));
const DashboardV2 = React.lazy(() => import("../pages/Dashboard/DashboardPage"));
const AnalyticsPage = React.lazy(() => import("../pages/Analytics/AnalyticsPage"));

export const history = createBrowserHistory();
export default function RouterApp() {
  return (
    <Provider store={store}>
      <ConfigProvider
        locale={viVN}
        renderEmpty={Empty}
        theme={dashboardTheme}
      >
        <HistoryRouter history={history}>
          <Suspense fallback={<LoadingProgress />}>
            <Routes>
              <Route path="" element={<RoutePrivate />}>
                <Route path="" element={<Body />}>
                  <Route path="*" element={<Page404 />} />
                  <Route index element={<DashboardV2 />} />
                  {/* <Route path="dashboard-v2" element={<DashboardV2 />} /> */}
                  <Route path="analytics" element={<AnalyticsPage />} />
                  <Route path="/store-manager" element={<TabStore />} />
                  <Route path="/list-account" element={<ListAccout />} />
                  <Route path="/employee-manager" element={<EmployeeManager />} />
                  <Route path="/mcoupon" element={<TableMcoupon />} />
                  <Route path="/donate-directly" element={<FormAddDonate />} />
                  <Route path="/voucher" element={<TableVoucher />} />
                  <Route path="/editUser" element={<EditUser />} />
                  <Route path="/restorePr" element={<Restore />} />
                  <Route path="/customer" element={<TableCustomer />} />
                  {/* Vào từ nút "Thùng rác" ở màn Khách hàng — cố ý KHÔNG thêm vào
                      sidebar: menu dựng từ API `security/user/menus`, muốn hiện ở đó
                      phải thêm bản ghi menu trong DB. */}
                  <Route path="/customer/trash" element={<TrashCustomer />} />
                  <Route path="/exchange-vouchers">
                    <Route path=":id" element={<RedeemDiscountCustomer />} />
                  </Route>
                  <Route path="/customer-see" element={<CustomerSee />} />
                  <Route
                    path="/transactions-customer"
                    element={<TransactionCustomer />}
                  />
                  <Route
                    path="/info-point-store"
                    element={<TableStoreCustomer />}
                  />
                  <Route
                    path="/rank-customer"
                    element={<TableRankCustomer />}
                  />
                  <Route
                    path="/customer-group"
                    element={<TableGroupCustomer />}
                  />
                  <Route
                    path="/customer-group/create"
                    element={<GroupCustomerCreate />}
                  />
                  <Route
                    path="/customer-group/:id"
                    element={<GroupCustomerDetail />}
                  />
                  <Route path="/transaction-payment" element={<Trade />} />
                  <Route
                    path="/transaction-history"
                    element={<HistoryTrade />}
                  />
                  <Route path="/detail-transaction-history">
                    <Route path=":id" element={<DetailHistory />} />
                  </Route>
                  <Route
                    path="/sent-smsgroup"
                    element={<SendGroupMessages />}
                  />
                  <Route path="/lich-su-gui-tin" element={<LogMessageHistories />} />
                  <Route path="/services" element={<TableService />} />
                  <Route path="/reward-types" element={<RewardTypeTable />} />
                  <Route
                    path="/point-mechanisms"
                    element={<PointMechanismsTable />}
                  />
                  <Route path="/zalo-events" element={<ZaloEventTable />} />
                  <Route path="/trademarks" element={<TrademarkTable />} />
                  <Route
                    path="/trademark-company-mapping"
                    element={<TrademarkCompanyMapping />}
                  />
                  <Route path="/zns-events" element={<ZnsEventTable />} />
                  <Route
                    path="/zns-event-branchs"
                    element={<ZnsEventBranchMapTable />}
                  />
                  <Route
                    path="/zalo-group-messages"
                    element={<ZaloGroupMessageTable />}
                  />
                  <Route path="/send-point" element={<SendPointCustomer />} />
                  {/* <Route
                    path="/change-point-customer"
                    element={<ChangePointCustomer />}
                  /> */}
                  <Route
                    path="/change-point-setting"
                    element={<ChangePointSettingTable />}
                  />
                  <Route
                    path="/suspension-point-settings"
                    element={<SuspensionPointSettingTable />}
                  />
                  <Route
                    path="/point-promotion"
                    element={<PointPromotionTable />}
                  />
                  <Route
                    path="/gift-exchanges"
                    element={<GiftExchangeTable />}
                  />
                  <Route
                    path="/add-gift-exchange"
                    element={<AddGiftExchangePage />}
                  />
                  <Route
                    path="/edit-gift-exchange/:id"
                    element={<EditGiftExchangePage />}
                  />
                  <Route
                    path="/gift-exchange-for-customers"
                    element={<GiftExchangeForCustomers />}
                  />
                  <Route
                    path="/gift-exchange-for-customer-histories"
                    element={<GiftExchangeForCustomerHistories />}
                  />
                  <Route
                    path="/scan-point-orders"
                    element={<ScanPointOrder />}
                  />
                  <Route
                    path="/map-service-branchs"
                    element={<MapServiceBranchTable />}
                  />

                  <Route path="/survey">
                    <Route index element={<RewardDataGwTable />} />
                    <Route path=":id" element={<RewardFormUpdate />} />
                  </Route>
                  <Route path="/store-survey" element={<RewardFormCreate />} />

                  <Route path="/survey-responses">
                    <Route path=":id" element={<SurveyResponsesList />} />
                  </Route>

                  <Route path="/banners" element={<BannerTable />} />
                  <Route path="/articles" element={<ArticleTable />} />
                  <Route path="/articles/create" element={<ArticleFormPage />} />
                  <Route path="/articles/:id/edit" element={<ArticleFormPage />} />
                  <Route
                    path="add-point-promotion"
                    element={<AddPointPromotionPage />}
                  />
                  <Route
                    path="/edit-point-promotion/:id"
                    element={<EditPointPromotionPage />}
                  />

                  <Route path="/logs" element={<LogScreen />} />
                  <Route path="/action-logs" element={<LogActionScreen />} />
                  <Route path="/permission" element={<ListPermission />} />
                  <Route path="/menu" element={<ListMenu />} />
                  <Route path="/create-menu" element={<CreateMenuPage />} />
                  <Route path="/update-menu/:id" element={<EditMenuPage />} />
                  <Route
                    path="/add-permission/:id"
                    element={<AddPermissionInUser />}
                  />

                  <Route path="/customer-detail">
                    <Route path=":id" element={<CustomerDetail />} />
                  </Route>
                  
                  <Route path="/game-configs" element={<LuckyWheelConfig />} />
                  <Route path="/game-configs/new" element={<ProgramForm />} />
                  <Route path="/game-configs/:id/edit" element={<ProgramForm />} />
                  <Route path="/game-configs/history" element={<GameHistory />} />
                  
                  <Route path="/product-categories" element={<ProductCategoryTable />} />
                  <Route path="/products" element={<ProductTable />} />
                  <Route path="/product-codes" element={<ProductCodeManager />} />
                  <Route path="/shinko/transactions" element={<ShinkoPointTransaction />} />
                  <Route path="/feedbacks" element={<FeedbackList />} />
                  <Route path="/thong-bao-nsx" element={<ManufacturerNotificationPage />} />
                </Route>
              </Route>
              <Route path="" element={<CheckLogin />}>
                <Route path="/login" element={<Login />} />
                {/* <Route path="/register" element={<Register />} /> */}
              </Route>
              
              <Route path="/khao-sat/:slug" element={<SurveyPublicPage />} />
            </Routes>
          </Suspense>
        </HistoryRouter>
      </ConfigProvider>
    </Provider>
  );
}
